import request from '@/utils/request'

/**
* 安全操作说明
*
* @author ljw
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = 'manage/safe-operation'

export const DOME_BASE_URL = BASE_URL


/**
* 查询指定ID安全操作说明数据
*
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}


/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}